import { updateCalendarCloudSettings } from '../actions/internalActions';
import { saveCalendarCloudSettings } from '../actions/publicActions';
import setCalendarCloudSettingsService from '../services/setCalendarCloudSettingsService';
import convertOptionsToCalendarCloudSettings from '../utils/convertOptionsToCalendarCloudSettings';
import { orchestrator } from 'satcheljs';

/**
 * Saves the calendar cloud settings
 */
orchestrator(saveCalendarCloudSettings, async actionMessage => {
    const { calendarCloudSettingsOptions } = actionMessage;

    const calendarCloudSettings = convertOptionsToCalendarCloudSettings(
        calendarCloudSettingsOptions
    );

    if (!calendarCloudSettings) {
        return;
    }

    updateCalendarCloudSettings(calendarCloudSettings);
    await setCalendarCloudSettingsService(calendarCloudSettings);
});
